import { workerRegistry } from '@/lib/agents/registry'
import { NodeProps } from '@xyflow/react'
import { Languages } from "lucide-react"
import { InlineHandles, WorkerLabeledHandle } from '../handles'
import { useWorker } from '../hooks'
import { MemoizedWorker } from '../memoizedworkers'
import { NodeLayout } from './node'
import { ConditionHandler } from '../condition'
import { MultiSelect } from '@/components/ui/multi-select'
import { languages } from '@/lib/agents/languages'
import { useState, useEffect } from 'react'

const { languageDetection } = workerRegistry

languageDetection.icon = Languages

const languageOptions = languages.map(lang => ({ label: lang.label, value: lang.value }))

function Parameters({ worker }: { worker: LanguageDetectionWorker }) {
  const [selectedLanguages, setSelectedLanguages] = useState<string[]>(worker.parameters.languages || [])

  useEffect(() => {
    worker.parameters.languages = selectedLanguages
  }, [selectedLanguages, worker])

  return <div className='px-2 nodrag w-full grow flex flex-col py-2'>
    <label className='text-xs font-medium text-gray-600 mb-1'>Languages (ISO 639-3)</label>
    <MultiSelect
      options={languageOptions}
      onValueChange={setSelectedLanguages}
      defaultValue={selectedLanguages}
      placeholder="Select languages..."
      maxCount={5}
    />
  </div>
}

export function LanguageDetectionNode(props: NodeProps) {
  const worker = useWorker<LanguageDetectionWorker>(props.id)

  return <NodeLayout worker={worker} resizable minHeight={200} minWidth={300} className='flex flex-col'>
    <InlineHandles>
      <WorkerLabeledHandle handler={worker.fields.input} />
      <WorkerLabeledHandle handler={worker.fields.language} />
    </InlineHandles>

    <MemoizedWorker worker={worker} name="parameters">
      <Parameters worker={worker} />
    </MemoizedWorker>

    <ConditionHandler />
  </NodeLayout>
}
